import { c as _c } from "react/compiler-runtime";
import { FileText, ImageIcon } from "lucide-react";
import type { ToolCategory } from "@/lib/tools";
import { cn } from "@/lib/utils";

/** 44 px tinted square: teal page for PDF, violet picture for images. */
export function ToolIcon(t0) {
  const $ = _c(8);
  const {
    category,
    className
  } = t0;
  const Icon = category === "pdf" ? FileText : ImageIcon;
  const t1 = category === "pdf" ? "bg-pdf-tint text-pdf" : "bg-image-tint text-image";
  let t2;
  if ($[0] !== className || $[1] !== t1) {
    t2 = cn("flex size-11 shrink-0 items-center justify-center rounded-[10px]", t1, className);
    $[0] = className;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== Icon) {
    t3 = <Icon className="size-[22px]" strokeWidth={1.8} aria-hidden="true" />;
    $[3] = Icon;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <span className={t2}>{t3}</span>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}